import { useNotification } from '@kyvg/vue3-notification';
import router from '@/router';
import store from '@/store/index.js';

const assetsPath = route => '/sport-station/espacepersonnel/';

const isObjectEmpty = obj => Object.keys(obj).length === 0;

const recursiveRouterExtraInfo = (routes, desiredRoute, previousRoute = null) => {
  let routeInfo = {};

  routes.map(route => {
    if (!isObjectEmpty(routeInfo)) {
      return route;
    }

    // We found desired submenus based on primary menu
    if (route.name === desiredRoute) {
      routeInfo = {
        name: route.name,
        parentName: previousRoute,
        component: route.component
      };

      return route;
    }

    // We recursive look for new routes in subchildrens, only if not home
    if (route.children) {
      const childrenSearch = recursiveRouterExtraInfo(route.children, desiredRoute, route.name);
      if (!isObjectEmpty(childrenSearch)) {
        routeInfo = childrenSearch;
      }
    }

    return route;
  });

  // Only return visible items
  return routeInfo;
};

const appendRouteItems = routes => {
  const foundChildrens = [];

  routes.map(child => {
    foundChildrens.push({
      visible: child.meta && child.meta.visible ? child.meta.visible : null,
      visibleWorkspaces: child.meta && child.meta.visibleWorkspaces ? child.meta.visibleWorkspaces : null,
      icon: child.meta && child.meta.icon ? child.meta.icon : '',
      title: child.meta && child.meta.title ? child.meta.title : child.name,
      pathName: child.name,
      path: child.path,
      meta: child.meta
    });
  });

  return foundChildrens;
};

const recursiveRouterChildrenFinder = (routes, desiredRoute) => {
  // If we want home items, we append first items
  if (desiredRoute === 'Home') {
    return appendRouteItems(routes);
  }

  let foundChildrens = [];

  routes.map(route => {
    // We found desired submenus based on primary menu
    if (route.name === desiredRoute && route.children) {
      foundChildrens = appendRouteItems(route.children);
    }

    // We recursive look for new routes in subchildrens, only if not home
    if (route.children) {
      foundChildrens = [...foundChildrens, ...recursiveRouterChildrenFinder(route.children, desiredRoute)];
    }
  });

  return foundChildrens;
};

const findRouteInformation = routeName => recursiveRouterExtraInfo(router.options.routes, routeName);

const matchExact = (r, str) => {
  if (!str) {
    return false;
  }

  const match = String(str).match(r);
  return match && String(str) === match[0];
};

const genderVocabulary = gender => {
  let title = 'Né';

  switch (gender) {
    case 'mr':
      title = 'Né';
      break;
    case 'mme':
      title = 'Née';
      break;
    case 'miss':
      title = 'Née';
      break;
    default:
      title = 'Né';
  }

  return title;
};

const lengthBetween = (str, min, max) => (str ? str.length >= min && str.length <= max : false);

const menuHandler = routeName => {
  const menus = recursiveRouterChildrenFinder(router.options.routes, routeName);

  // Only return visible items
  return menus.filter(v => {
    if (v.visibleWorkspaces) {
      if (!v.visibleWorkspaces.includes(store.state.siteInfo.workspace)) {
        return false;
      }
    }
    if (typeof (v.visible) === 'function') {
      return v.visible();
    }
    return v.visible;
  });
};

const routeIsCurrentComponent = (routeName, component) => {
  const route = recursiveRouterExtraInfo(router.options.routes, routeName);

  if (route) {
    // eslint-disable-next-line no-underscore-dangle
    if (route.component.render === component.render) return true;
    return false;
  }

  return false;
};

const isRecette = href => (href.includes('recette.') ? 'https://community.stage.ucpa.com' : 'https://communaute.ucpa.com');

const goBack = route => {
  const routeInfo = findRouteInformation(route.name);
  router.replace({ name: routeInfo.parentName });
};

const isInImpersonateModeNotification = () => {
  const notification = useNotification();

  if (store.getters.isImpersonateMode) {
    notification.notify({
      type: 'error',
      title: "Vous êtes en mode impersonate, aucune action n'est autorisée"
    });
    return true;
  }

  return false;
};

const menuItems = routeName => {
  const disabled_features = store.state.siteInfo.perso_settings && store.state.siteInfo.perso_settings.disabled_features ? store.state.siteInfo.perso_settings.disabled_features : [];
  const items = menuHandler(routeName).filter(item => !disabled_features.includes(item.path));

  return items.filter(item => {
    if (item && item.meta && item.meta.show) {
      if (store.state.siteInfo.perso_settings && store.state.siteInfo.perso_settings.conditions) {
        return item.meta.show.some(cond => store.state.siteInfo.perso_settings.conditions.includes(cond));
      }
      return false;
    }
    return true;
  });
};

const generateFunnelUrl = offer => {
  const { siteInfo, impersonateData } = store.state;
  let baseURL = `${offer.funnelUrl}?workspace=${siteInfo.workspace}&product=${offer.productUuid}&offer=${offer && offer.horanet_product && offer.horanet_product.horanet_product_code && !siteInfo.is_internal_session ? offer.horanet_product.horanet_product_code : offer.uuid}`;

  if (impersonateData) {
    baseURL = `${baseURL}&impersonateData=${encodeURI(impersonateData)}`;
  }

  return baseURL;
};

export {
  menuItems,
  isInImpersonateModeNotification,
  findRouteInformation,
  isObjectEmpty,
  matchExact,
  genderVocabulary,
  lengthBetween,
  menuHandler,
  isRecette,
  assetsPath,
  goBack,
  routeIsCurrentComponent,
  generateFunnelUrl
};
